import React from "react";
import {
    loadWord,
    parseXml,
    convertMultilingualParagraphs
} from "../../utils/News/wordParser";


export default function WordImporter({
    activeLanguage,
    setNewsData
}) {


    const handleImport = async (e) => {

        const file = e.target.files?.[0];

        if (!file) return;


        try {

            const result = await loadWord(file);


            const xml =
                parseXml(
                    result.documentXml
                );


            const content = convertMultilingualParagraphs(xml);



            console.log(
                "Imported content:",
                content
            );


            setNewsData(prev => ({
                ...prev,
                ...Object.keys(content).reduce((languages, language) => ({
                    ...languages,
                    [language]: {
                        ...prev[language],
                        content: content[language]
                    }
                }), {})
            }));


        } catch(error){

            console.error(
                "Import word error:",
                error
            );

        }

    };



    return (

        <input
            type="file"
            accept=".docx"
            onChange={handleImport}
        />

    );

}